module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/m0-1e36dfec0d35f1f4b68e180c897fa9ff.png";